import React from 'react'
import Header from './Components/Header'
import Footer from './Components/Footer'

const MoreProducts = () => {
  return (
    <div>
    <div> 
    <Header/>
    </div>
    <div className="inner-image-header">
        <div className="inner-image-text-about">
        <h1 className='heading-about'> More Products</h1>
          <p>
            Coming Soon
          </p>
        </div>
      </div>
      <div> 
      <Footer/>
      </div>
    </div>
  )
}

export default MoreProducts